import { ThunkType } from "../../../../../core/store/reducers";
import { getBusinesActivitiesExcel } from "../api/getBusinessActivitiesExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../businessActivitiesDataSlice";

export const downloadBusinessActivitiesExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.businessActivities;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getBusinesActivitiesExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "BusinessActivities.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
